/**
 * UpCart shows Shopify selling-plan names. Relabel lines marked via _fw_delivery
 * when the cart line is Every 60 Days but the plan name still says Every 30 Days.
 */
(function () {
  var LABEL_60 = 'Every 60 Days';

  function getUpcartRoot() {
    if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot;
    return document.querySelector('.upcart-cart');
  }

  function itemIs60(item) {
    if (!item) return false;
    var props = item.properties || {};
    var delivery = props._fw_delivery || props['_fw_delivery'] || '';
    return String(delivery).indexOf('60') !== -1;
  }

  function relabelInRoot(root, sixtyVariantIds) {
    if (!root) return;
    var nodes = root.querySelectorAll('p, span, div, small, li');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children && el.children.length) continue;
      var text = (el.textContent || '').trim();
      if (!/^every\s*30\s*days$/i.test(text)) continue;
      if (!sixtyVariantIds || !sixtyVariantIds.length) continue;
      var line = el.closest('[class*="item"], [class*="line"], [class*="product"], [class*="cart"]');
      var blob = ((line && line.textContent) || '').toLowerCase();
      var looks60 = sixtyVariantIds.some(function (id) {
        return blob.indexOf(String(id)) !== -1;
      });
      if (looks60) el.textContent = LABEL_60;
    }
  }

  function apply() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var sixtyVariantIds = items.filter(itemIs60).map(function (item) {
          return item.variant_id;
        });
        if (!sixtyVariantIds.length) {
          relabelInRoot(getUpcartRoot(), []);
          return;
        }
        relabelInRoot(getUpcartRoot(), sixtyVariantIds);
      })
      .catch(function () {
        relabelInRoot(getUpcartRoot(), []);
      });
  }

  function schedule() {
    requestAnimationFrame(function () {
      apply();
      window.setTimeout(apply, 80);
      window.setTimeout(apply, 300);
    });
  }

  var subscribed = false;
  function subscribe() {
    if (subscribed) return true;
    var loadSub = window.upcartSubscribeCartLoaded;
    var updateSub = window.upcartSubscribeCartUpdated;
    if (typeof loadSub !== 'function' && typeof updateSub !== 'function') return false;
    if (typeof loadSub === 'function') loadSub(schedule);
    if (typeof updateSub === 'function') updateSub(schedule);
    subscribed = true;
    schedule();
    return true;
  }

  function init() {
    schedule();
    if (!subscribe()) {
      [200, 600, 1500, 3000, 6000].forEach(function (ms) {
        window.setTimeout(subscribe, ms);
      });
    }
    [200, 600, 1500, 3000].forEach(function (ms) {
      window.setTimeout(apply, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
